
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/matarsoun",
      function () {
        return require("private-next-pages/matarsoun.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/matarsoun"])
      });
    }
  